import {Component, ViewEncapsulation} from '@angular/core';
import {LayoutDefaultComponent} from '@labshare/base-ui/layout-default';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LayoutComponent extends LayoutDefaultComponent {
  constructor() {
    super();
  }
}
